import { branding } from '../config.js';

export const helpLinks = [
  {
    href: '/docs/major-concepts',
    label: 'Documentation',
    track: 'Clicked Documentation'
  },
  {
    href: '/changelog',
    label: 'Changelog',
    track: 'Clicked Changelog'
  },
  {
    href: branding.linkSlack,
    label: 'Slack Community',
    track: 'Clicked Slack Community'
  }
].filter((link) => Boolean(link.href));

export const legalLinks = [
  {
    href: branding.linkTerms,
    label: 'Terms',
    track: 'Clicked Terms and Conditions'
  },
  {
    href: branding.linkPrivacy,
    label: 'Privacy Policy',
    track: 'Clicked Privacy Policy'
  }
].filter((link) => Boolean(link.href));

export const helpAndLegalLinks = helpLinks.concat(legalLinks);
